import React, { cloneElement } from 'react';
import { typeOf } from 'react-is';
export default function addClassName(element, className) {
  var _newElement$props$cla;

  if (!typeOf(element)) return element;
  const newElement = element;
  return /*#__PURE__*/cloneElement(newElement, {
    className: `${(_newElement$props$cla = newElement.props.className) != null ? _newElement$props$cla : ''} ${className}`
  });
}